var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.375v-6.375h-9.375c-0.623 0-1.125 0.502-1.125 1.125v21.75c0 0.623 0.502 1.125 1.125 1.125h15.75c0.623 0 1.125-0.502 1.125-1.125v-15.375h-6.375c-0.619 0-1.125-0.506-1.125-1.125zM16.5 17.437c0 0.309-0.253 0.563-0.563 0.563h-7.875c-0.309 0-0.563-0.253-0.563-0.563v-0.375c0-0.309 0.253-0.563 0.563-0.563h7.875c0.309 0 0.563 0.253 0.563 0.563v0.375zM16.5 14.437c0 0.309-0.253 0.563-0.563 0.563h-7.875c-0.309 0-0.563-0.253-0.563-0.563v-0.375c0-0.309 0.253-0.563 0.563-0.563h7.875c0.309 0 0.563 0.253 0.563 0.563v0.375zM16.5 11.063v0.375c0 0.309-0.253 0.563-0.563 0.563h-7.875c-0.309 0-0.563-0.253-0.563-0.563v-0.375c0-0.309 0.253-0.563 0.563-0.563h7.875c0.309 0 0.563 0.253 0.563 0.563zM21 5.714v0.286h-6v-6h0.286c0.3 0 0.586 0.117 0.797 0.328l4.589 4.594c0.211 0.211 0.328 0.497 0.328 0.792z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.046b0ba655c2d9b90b3c10193e2b45ec.svg";
export { ForwardRef as ReactComponent };